var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-timepicker',_vm._g({attrs:{"id":_vm.id,"name":_vm.name,"value":_vm.value,"placeholder":_vm.placeholder,"disabled":_vm.disabled,"readonly":_vm.readonly,"required":_vm.required,"state":_vm.state,"size":_vm.size,"hour12":_vm.hour12,"minutes-step":_vm.step},on:{"input":(value) => _vm.$emit('input', value)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }